export default __webpack_public_path__ + "static/media/botanyIcon.6090fc50.svg";